import { Injectable } from '@angular/core';
import { PageKeyService } from '@wdpr/ra-angular-page-key';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FinderPageKeyService {
    private pageKey$ = new BehaviorSubject('');
    private fallbackPageKey = '';

    constructor(
        private pageKeyService: PageKeyService,
    ) {
        this.init();
    }

    pageKeyReady(): Observable<any> {
        return this.pageKey$.asObservable();
    }

    get() {
        return this.pageKey$.getValue();
    }

    clearPageKey() {
        this.pageKey$.next('');
    }

    setFallbackPageKey(url: string) {
        /**
         * We don't always have a fallback URL.
         *
         * Also relative urls will pass through. The original response from the detail request
         * will have the absolute path. Internal redirects will only have a relative value.
         */
        if (!url || !url.startsWith('http')) {
            return;
        }

        const parsedUrl = new URL(url);
        const pathParts = parsedUrl.pathname.split('/');

        // Toss the first value
        pathParts.shift();

        if (pathParts.length > 0) {
            this.fallbackPageKey = pathParts[0];
        }
    }

    getFallbackPageKey() {
        return this.fallbackPageKey;
    }

    getParts() {
        // Split the page key value on "dots", ignoring any trailing dot
        // Then, splice off the first part of the array post-split as it is the siteId
        const pageKeyParts = this.get().replace(/\.$/, '').split('.').slice(1);
        const result: any = {
            type: pageKeyParts[0],
            friendlyId: pageKeyParts[pageKeyParts.length - 1]
        };

        // Check if there is the parkName
        // The format of the page key should be one of two:
        // type.parkName.friendlyId or type.friendlyId
        result.parkName = pageKeyParts.length === 3 ? pageKeyParts[1] : '';

        return result;
    }

    private init() {
        this.pageKeyService
        .pipe(
            map(pk => {
                this.pageKey$.next(pk.key);
            })
        )
        .subscribe();
    }
}
